import { calculateFirstQtyQuoteTotal } from '@calculations/price/quote-total';
import { createSelector } from '@reduxjs/toolkit';
import { selectDecimalPlaces } from '@ui/features/quote-builder/state/selectors/decimal-places';
import { getCurrencyFormatForSite } from '@ui/features/quote-builder/state/utilities/format-price-breaks';
import { transformStoreStateToNestedQuoteLinesAndPrices } from '@ui/features/quote-builder/state/utilities/transform-quote';
import type { RootState } from '@ui/store';
import { currency } from '@ui/util';

import { selectQuoteBuilder } from '../selectors/quote-builder';

export const selectQuoteTotal = createSelector(
  [
    (state: RootState) => selectQuoteBuilder(state).quoteLines,
    (state: RootState) => selectQuoteBuilder(state).siteCode,
    selectDecimalPlaces,
  ],
  (quoteLines, siteCode, decimalPlaces) => {
    if (!quoteLines || !siteCode) {
      return null;
    }

    const transformedQuoteLines =
      transformStoreStateToNestedQuoteLinesAndPrices(quoteLines);

    const { total } = calculateFirstQtyQuoteTotal({
      snapQuoteLinesWithPrices: transformedQuoteLines,
    });

    return currency(
      total.toFixed(decimalPlaces),
      getCurrencyFormatForSite(siteCode),
    );
  },
);
